<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import Rem from '../config/rem.js'
  export default {
    name: 'App'
  }
</script>

<style>
  #app {}

  a {
    text-decoration: none;
  }

  html::-webkit-scrollbar,
  body::-webkit-scrollbar {
    display: none;
  }
body{
  font-size: 12px;
  line-height: normal !important;

}
  html,
  body {
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  * {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .swiper-pagination-progress
  .swiper-pagination-progressbar {
  		background: #007aff;
  		position: absolute;
  		left: 0;
  		top: 0;
  		width: 100%;
  		height: 100%;
  		-webkit-transform: scale(0);
  		-ms-transform: scale(0);
  		-o-transform: scale(0);
  		transform: scale(0);
  		-webkit-transform-origin: left top;
  		-moz-transform-origin: left top;
  		-ms-transform-origin: left top;
  		-o-transform-origin: left top;
  		transform-origin: left top;
  	}
    .van-dropdown-menu__bar{
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue